import * as moment from 'moment';
import { useMemo } from 'react';
import { ITicketForList } from '@nkr/models/index';
import { TicketStatus } from '@nkr/enums/index';
import { GridWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, FirstDataRenderedEvent, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

interface IProps {
    list: ITicketForList[],
    centerId: number,
    onOpen: (ticketId: number) => void,
    onDelete: (ticketId: number) => void,
    onCloseReopen: (ticketId: number, status: TicketStatus) => void,
}

const CenterList = (props: IProps) => {
    const getRowStyle = (params: any) => {
        if (params.data.ticketStatusId == TicketStatus.Closed) {
            return { color: '#bbb' };
        }
    };

    const cols: ColDef[] = [
        {
            field: 'id',
            headerName: '',
            width: 80,
            cellClass: 'list-cell action-menu',
            cellRendererFramework: (params: ICellRendererParams) => <a href={`/center/${props.centerId}/action-center/support/view-ticket/${params.value}`}>View</a>
        },

        {
            headerName: 'From and Subject',
            headerClass: 'list-header',
            headerComponentFramework: () => <>From &amp; Subject</>,
            width: 580,
            cellClass: 'list-cell-left',
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as ITicketForList;
                let { contactId, contactName, contactEmail, isMissingData } = data;

                if (contactId > 0 && isMissingData == false)
                    return (
                        <div style={{ textAlign: 'left', width: '100%' }}>
                            {contactEmail ? `${contactName} (${contactEmail})` : contactName}<br />
                            subject: {data.subject ? data.subject : '[No Subject]'}
                        </div>
                    );

                return null;
            }
        },

        {
            headerName: 'Agent',
            headerClass: 'list-header',
            headerComponentFramework: () => <>Agent</>,
            width: 250,
            cellClass: 'list-cell',
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as ITicketForList;

                return (
                    <>
                        {data.assignedUserId == 0 ?
                            <span>[PENDING ASSIGMENT]</span>
                            :
                            <span>{data.userName}</span>
                        }
                    </>
                );
            }
        },

        {
            field: 'statusDescription',
            headerName: 'Status',
            headerClass: 'list-header',
            headerComponentFramework: () => <>Status</>,
            width: 140,
            cellClass: 'list-cell',
        },

        {
            field: 'createdDateTime',
            headerName: 'Date Submitted',
            headerClass: 'list-header',
            headerComponentFramework: () => <>Date Submitted</>,
            width: 140,
            cellClass: 'list-cell',
            valueGetter: (props: ValueGetterParams) => props.data.createdDateTimeForSort,
            cellRendererFramework: (params: ICellRendererParams) => <>{moment(params.data.createdDateTime).format('MM/DD/YYYY')}</>
        },

        {
            field: 'lastUpdatedDateTime',
            headerName: 'Last Updated',
            headerClass: 'list-header',
            headerComponentFramework: () => <>Last Updated</>,
            width: 140,
            cellClass: 'list-cell',
            valueGetter: (props: ValueGetterParams) => props.data.lastUpdatedDateTime,
            cellRendererFramework: (params: ICellRendererParams) => <>{moment(params.data.lastUpdatedDateTime).format('MM/DD/YYYY')}</>
        },

        {
            field: 'closedDateTime',
            headerName: 'Date Submitted',
            headerClass: 'list-header',
            headerComponentFramework: () => <>Date Submitted</>,
            width: 140,
            cellClass: 'list-cell',
            valueGetter: (props: ValueGetterParams) => props.data.createdDateTimeForSort,
            cellRendererFramework: (params: ICellRendererParams) => <>{moment(params.data.createdDateTime).format('MM/DD/YYYY')}</>
        },

        {
            field: 'urgencyId',
            headerName: 'Urgent?',
            headerClass: 'list-header',
            headerComponentFramework: () => <>Urgent?</>,
            width: 140,
            cellClass: 'list-cell',
            cellRendererFramework: (params: ICellRendererParams) =>
                <>
                    {parseInt(params.value) != 0 ? 'Yes' : 'No'}
                </>
        }
    ];

    const columnDefs = useMemo(() => cols, []);
    const rowData = useMemo(() => props.list, [props.list]);

    return (
        <GridWrapper
            width={'100%'}
            height={'65vh'}
            headerBgColor={'#ddd'}
            headerFontColor={'#123'}
            headerFontWeight={700}
            className='ag-theme-bootstrap'
            style={{ marginBottom: 10 }}
        >
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                suppressCellSelection={true}
                rowHeight={50}
                getRowStyle={getRowStyle}
                noRowsOverlayComponentFramework={() => <>No tickets found...</>}
                onFirstDataRendered={(props: FirstDataRenderedEvent) => props.api.sizeColumnsToFit()}
            />
        </GridWrapper >
    );
}

export default CenterList;